import request from '../../../../setup/axios/request'

export const searchAndPagingRenewContract = (data: any) => {
  let obj = {}
  if (data) {
    obj = {
      Filters: data.filter,
      Page: data.pageNum.toString(),
      PageSize: data.pageSize.toString(),
    }
  }
  return request({
    url: '/api/v1/SellingStep/get-list-synthesis-contract-renew',
    method: 'get',
    headers: {
      'x-query': JSON.stringify(obj),
    },
  })
}

export const cancelRenew = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/cancel-renew',
    method: 'post',
    data: data,
  })
}

export const sendmailRenewB2c = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/sendmail-renew-b2c',
    method: 'post',
    data: data,
  })
}

export const updateCustomerEx = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/update-customer-ex',
    method: 'post',
    data: data,
  })
}
export const calculateNewFeeContract = (data: any) => {
  return request({
    url: '/api/v1/SellingStep/step4-calculateNewFee-contract',
    method: 'post',
    data: data,
  })
}

export const exportRenewContract = (data: any) => {
  return request({
    url:
      '/api/v1/Report/get-export-renew-contract?fromDate=' +
      data.fromDate +
      '&toDate=' +
      data.toDate +
      '&contractKind=' +
      data.contractKind +
      '&masterCode=' +
      data.masterCode,
    method: 'get',
  })
}
